"use strict";

window.$ = window.jQuery = require('jquery');

export default function () {
    window.jQuery(document).ready(function ($) {
        $('*[data-bind]').each(function() {
            let $bound = $(this);

            if($bound.attr('data-bind') + '' === '') {
                return;
            }

            if($bound.attr('data-value') + '' === '') {
                return;
            }

            $bound.click(function() {
                let $source = $(this);
                let $input = $('#' + $source.attr('data-bind'));

                $input.val($source.attr('data-value'));
            });
        });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/bind.js